import { merge as _merge } from 'lodash'
import es from 'core/translations/es'

export default _merge(es, {
  error: {
    GUCCI_ERROR_PRODUCT_VARIANT: 'SKU variante. Utiliza la operación Encoding LG de muestreo.',
    GUCCI_ERROR_PRODUCT_NOT_VARIANT: 'SKU no variante. Utiliza la operación Encoding LG.',
    GUCCI_SHOES_ERROR_PRODUCT_VARIANT: 'SKU variante. Utiliza la operación Encoding Calzado de muestreo.',
    GUCCI_SHOES_ERROR_PRODUCT_NOT_VARIANT: 'SKU no variante. Utiliza la operación Encoding Calzado.',
    GUCCI_ERROR_PRODUCT_MISSING_EAN: 'SKU no variante, EAN faltante. No es posible proceder. Contacta con soporte.'
  },
  custom: {
    NFC_PRODUCT_NOT_ALLOWED: 'El SKU requiere una etiqueta NFC. Por favor, usa la funcionalidad de Control de Producto.'
  }
})
